import { Dispatch } from 'redux';

import { showChangeApplicationDialog } from 'src/actions/imstat';
import { IClassStayMealInfo } from 'src/containers/CareerStayMeal';
import * as Actions from '../actions/search';
import { IStayMealDateList } from '../actions/search';
import i18n from '../resources/i18n';
import { isMobile } from '../utils/MobileCheck';
import { IOptions } from '../utils/Transfers';
import AbstractScenario from './AbstractScenario';
import { ICancelApplicationParam } from './ImstatScenarioFactory';

// 受講申請シナリオ用パラメータ
export interface IApplyCareersParam {
	careerType: number;
	applies: Actions.IApply[];
	reason: string;
}

export interface IStayMealSearchParam {
	careerId: string;
	classId: string;
}

export interface ICancelAndUpdateClassParam {
	careerAppl: IApplyCareersParam;
	reqCancelReq: ICancelApplicationParam;
}
/**
 * 検索シナリオファクトリ
 */
export default class SearchScenarioFactory {
	/**
	 * eラーニングSCORM情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchCategoryCareerTree(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process({}) {
				const param = {
					isMobile: isMobile(),
				};
				return this.read(
					'per_search_CategoryCareerTreeBlockModel',
					param
				).then(data => {
					const categories = data.treeList.map((item: any) =>
						SearchScenarioFactory.toSearchCategoryItem(item)
					);
					this.dispatch(Actions.setSearchCategories({ categories }));
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 詳細検索用表示情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchSearchConditionDispInfo(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process({}) {
				const param = {
					_tsqGenericDataType:
						'per_search_searchDetailMemberCollection',
				};

				return this.read('tsq_common_GenericDataModel', param).then(
					data => {
						this.dispatch(
							Actions.setCareerSearchConditionDetail({ data })
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 詳細検索シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchDetailCareerList(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.ICareerSearchCondition
		> {
			protected process(arg: Actions.ICareerSearchCondition) {
				const param: IOptions = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: 10,
					assessment: arg.assessment,
					careerType: arg.careerType,
					categoryId: arg.categoryId,
					categoryName: arg.categoryName,
					elearning: arg.elearning,
					endDate: arg.endDate,
					freeword: arg.freeword,
					jobCategory: arg.jobCategory,
					lowerFlg: arg.lowerFlg,
					office: arg.office,
					onlyWanted: arg.onlyWanted,
					position: arg.position,
					qualification: arg.qualification,
					shugo: arg.shugo,
					skillTypeList: arg.skillTypeList,
					sonota: arg.sonota,
					startDate: arg.startDate,
					tuusin: arg.tuusin,
					workExperience: arg.workExperience,
				};
				if (arg.startDate && arg.startDate !== '') {
					param.startDate = arg.startDate.replace(/\-/g, '/');
					param.startDate = param.startDate.replace('T', ' ');
				} else {
					param.startDate = '';
				}
				if (arg.endDate && arg.endDate !== '') {
					param.endDate = arg.endDate.replace(/\-/g, '/');
					param.endDate = param.endDate.replace('T', ' ');
				} else {
					param.endDate = '';
				}
				if (arg.detail) {
					param.detail = arg.detail.map(
						(item: Actions.ICareerSearchDetailCondition) => ({
							items: item.items,
							text: item.text,
							type: item.type,
						})
					);
				}

				// 初期化
				this.dispatch(
					Actions.setSearchDetails({
						applyFlg: 0,
						data: [],
					})
				);
				return this.read(
					'per_search_CareerListBlockCollection',
					param
				).then(data => {
					this.dispatch(
						Actions.setSearchDetails({
							applyFlg: data.applyFlg,
							data: data.careerResults,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 申請用詳細検索シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchDetailCareerListForApply(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.ICareerSearchCondition
		> {
			protected process(arg: Actions.ICareerSearchCondition) {
				const param: IOptions = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: 10,
					careerIDs: arg.careerIDs,
					careerType: arg.careerType,
					categoryId: arg.categoryId,
					categoryName: arg.categoryName,
					elearning: arg.elearning,
					endDate: arg.endDate,
					freeword: arg.freeword,
					jobCategory: arg.jobCategory,
					lowerFlg: arg.lowerFlg,
					office: arg.office,
					onlyWanted: arg.onlyWanted,
					position: arg.position,
					shugo: arg.shugo,
					startDate: arg.startDate,
					targetCareerId: arg.targetCareerId,
					targetUserId: arg.targetUserId,
					tuusin: arg.tuusin,
				};
				if (arg.startDate && arg.startDate !== '') {
					param.startDate = arg.startDate.replace(/\-/g, '/');
					param.startDate = param.startDate.replace('T', ' ');
				} else {
					param.startDate = '';
				}
				if (arg.endDate && arg.endDate !== '') {
					param.endDate = arg.endDate.replace(/\-/g, '/');
					param.endDate = param.endDate.replace('T', ' ');
				} else {
					param.endDate = '';
				}
				if (arg.detail) {
					param.detail = arg.detail.map(
						(item: Actions.ICareerSearchDetailCondition) => ({
							items: item.items,
							text: item.text,
							type: item.type,
						})
					);
				}

				// 初期化
				this.dispatch(
					Actions.setSearchDetailsForApply({
						applyFlg: 0,
						data: [],
					})
				);
				return this.read(
					'per_search_CareerListBlockCollection',
					param
				).then(data => {
					this.dispatch(
						Actions.setSearchDetailsForApply({
							applyFlg: data.applyFlg,
							data: data.careerResults,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 申請情報検索シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchApprovals(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.IApprovalSearchCondition
		> {
			protected process(arg: Actions.IApprovalSearchCondition) {
				const param: IOptions = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: 10,
					applies: arg.applies.map(
						(
							apply: Actions.IApply
						): {
							[key: string]: string;
						} => ({
							careerId: apply.careerId,
							classId: apply.classId,
						})
					),
					careerType: arg.careerType,
				};

				// 初期化
				this.dispatch(
					Actions.setApprovals({
						data: [],
					})
				);
				return this.read(
					'per_search_ApproverListBlockCollection',
					param
				).then(data => {
					this.dispatch(
						Actions.setApprovals({
							data: data.approverResults,
						})
					);
					if (data.UseFacilityFlg) {
						this.dispatch(
							Actions.setUseFacilityFlg({
								useFacilityFlg: data.UseFacilityFlg,
							})
						);
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * クラス情報検索シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchClassApprovals(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			Actions.IApprovalClassSearchCondition
		> {
			protected process(arg: Actions.IApprovalClassSearchCondition) {
				const param: IOptions = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: 10,
					careerType: arg.careerType,
					targetCareerId: arg.targetCareerId,
				};

				// 初期化
				this.dispatch(
					Actions.setApprovals({
						data: [],
					})
				);
				return this.read(
					'per_search_ApproverListBlockCollection',
					param
				).then(data => {
					this.dispatch(
						Actions.setApprovals({
							data: data.approverResults,
						})
					);
					if (data.UseFacilityFlg) {
						this.dispatch(
							Actions.setUseFacilityFlg({
								useFacilityFlg: data.UseFacilityFlg,
							})
						);
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * カテゴリマスタ取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchCategoryMst(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(careerType: string) {
				const param = {
					accessType: '10',
					careerSearchMode: '0',
					careerType,
				};

				return this.read(
					'com_category_CategoryTreeBlockModel',
					param
				).then(data => {
					const caregoryList: Actions.ICategoryMst[] = data.categoryDisp.map(
						(item: any) =>
							SearchScenarioFactory.toCategoryItem(item)
					);
					if (careerType === '0') {
						this.dispatch(
							Actions.setCategoryMst({
								careerCategories: caregoryList,
								curriculumCategories: [],
								skillCategories: [],
							})
						);
					} else if (careerType === '10') {
						this.dispatch(
							Actions.setCategoryMst({
								careerCategories: [],
								curriculumCategories: [],
								skillCategories: caregoryList,
							})
						);
					} else if (careerType === '90') {
						this.dispatch(
							Actions.setCategoryMst({
								careerCategories: [],
								curriculumCategories: caregoryList,
								skillCategories: [],
							})
						);
					}
					this.dispatch(
						Actions.openSearchCondCategorySelect({
							open: true,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 研修情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchCareerDetail(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(careerId: string) {
				// 初期化
				this.dispatch(
					Actions.setCareerDetail({
						careerClasses: [],
						careerInfo: {},
					})
				);

				// データ取得
				const doScenario = SearchScenarioFactory.createDoFetchCareerDetail(
					this.dispatch,
					this.token
				);
				return doScenario.run(careerId).then(data => {
					this.dispatch(Actions.setCareerDetail(data));
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 研修情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createDoFetchCareerDetail(
		dispatch: Dispatch,
		token: string,
		getAllClassesFlgItem?: boolean
	) {
		let getAllClassesFlg = false;
		if (getAllClassesFlgItem !== undefined) {
			getAllClassesFlg = getAllClassesFlgItem;
		}
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(careerId: string) {
				const param = {
					accessType: 10,
					careerId,
					getAllClassesFlg,
					menuId: 0,
					type: 1,
				};
				return this.read(
					'com_career_CareerInfoClassInfoBlockCollection',
					param
				).then(data => ({
					careerClasses: data.careerClassInfoList as Actions.ICareerClass[],
					careerInfo: data.carerrInfoDTO as Actions.ICareerInfo,
				}));
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * カリキュラム情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchCurriculumDetail(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(careerId: string) {
				// 初期化
				this.dispatch(
					Actions.setCurriculumDetail({
						curriculumInfo: {},
						showHRAttribute: '',
					})
				);

				const doScenario = SearchScenarioFactory.createDoFetchCurriculumDetail(
					this.dispatch,
					this.token
				);
				return doScenario.run(careerId).then(data => {
					this.dispatch(Actions.setCurriculumDetail(data));
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * カリキュラム情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createDoFetchCurriculumDetail(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(careerId: string) {
				const param = {
					accessType: 10,
					careerId,
					careerTypeId: 90,
					lang: i18n.language,
				};

				// データ取得
				return this.read(
					'com_career_CurriculumInfoWindowCompositeModel',
					param
				).then(data => ({
					curriculumInfo: data.curriculumInfo as Actions.ICurriculumInfo,
					showHRAttribute: data.useJinjiZokusei as string,
				}));
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 章立て情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchCourseDetail(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(careerId: string) {
				const param = {
					accessType: 10,
					careerId,
				};
				// 初期化
				this.dispatch(
					Actions.setCourseDetail({
						courseInfo: {},
						courseTopics: [],
					})
				);
				return this.read(
					'com_career_CourseInfoWindowCompositeModel',
					param
				).then(data => {
					const courseInfo = data.courseInfo;
					const courseTopics = data.courseTopicInfoList.map(
						(item: any) =>
							SearchScenarioFactory.toCourseTopicItem(item)
					);
					this.dispatch(
						Actions.setCourseDetail({ courseInfo, courseTopics })
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * カリキュラム達成条件取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchCurriculumAchieveCondition(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(careerId: string) {
				const param = {
					accessType: 10,
					careerId,
					careerTypeId: 90,
					isMobile: isMobile(),
				};
				// 初期化
				this.dispatch(
					Actions.setCurriculumAchieveCondition({
						curriculumInfo: {},
						optionalCareers: [],
						requiredCareers: [],
					})
				);

				return this.read(
					'com_career_CurriculumRequiredWindowCompositeModel',
					param
				).then(data => {
					this.dispatch(
						Actions.setCurriculumAchieveCondition({
							curriculumInfo: {
								careerId: data.careerId,
								careerName: data.careerName,
								credit: data.credit,
							},
							optionalCareers: data.optionalCareer,
							requiredCareers: data.requiredCareer,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 受講申請前メッセージ取得
	 */
	public static createFetchCanApproval(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IApplyCareersParam
		> {
			protected process(arg: IApplyCareersParam) {
				const param = {
					accessType: 10,
					applies: arg.applies.map(
						(
							item: Actions.IApply
						): {
							[key: string]: string | boolean | null | any;
						} => ({
							approverId1: item.approverId1,
							approverId2: item.approverId2,
							approverId4: item.approverId4,
							cancelWaitFlg: item.cancelWaitFlg,
							careerId: item.careerId,
							classId: item.classId,
							stayMealData: item.stayMealData.map(
								(
									item1: Actions.IApprovalStayMealData
								): {
									[key: string]:
										| string
										| boolean
										| null
										| any;
								} => ({
									UID: item1.UID,
									careerID: item1.careerID,
									classID: item1.classID,
									comment: item1.Comment,
									sexFlg: item1.SexFlg,
									smokingFlg: item1.SmokingFlg,
									stayMealDateList: item1.StayMealDateList.map(
										(
											it: IClassStayMealInfo
										): {
											[key: string]:
												| string
												| boolean
												| null;
										} => ({
											executionDate: it.ExecutionDate,
											mealAfternoonFlg:
												it.MealAfternoonFlg,
											mealEveningFlg: it.MealEveningFlg,
											mealMorningFlg: it.MealMorningFlg,
											stayFlg: it.StayFlg,
										})
									),
								})
							),
						})
					),
					careerType: arg.careerType,
					reason: arg.reason,
				};

				return this.read(
					'per_search_ApprovalReasonBlockModel',
					param
				).then(data => {
					if (
						data.message.messageId &&
						data.message.messageId !== ''
					) {
						this.dispatch(
							Actions.setCanApproval({
								data: {
									messageId: data.message.messageId,
									replacementStringList:
										data.message.replacementStringList,
								},
								isOpenCanApproval: true,
							})
						);
					} else {
						this.dispatch(
							Actions.openApprovalConfirm({
								open: true,
							})
						);
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 受講申請シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createApplyCareers(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IApplyCareersParam
		> {
			protected process(arg: IApplyCareersParam) {
				const param = {
					accessType: 10,
					applies: arg.applies.map(
						(
							item: Actions.IApply
						): {
							[key: string]: string | boolean | null | any;
						} => ({
							approverId1: item.approverId1,
							approverId2: item.approverId2,
							approverId4: item.approverId4,
							cancelWaitFlg: item.cancelWaitFlg,
							careerId: item.careerId,
							classId: item.classId,
							endDate: item.endDate,
							startDate: item.startDate,
							stayMealData: item.stayMealData.map(
								(
									item1: Actions.IApprovalStayMealData
								): {
									[key: string]:
										| string
										| boolean
										| null
										| any;
								} => ({
									UID: item1.UID,
									careerID: item1.careerID,
									classID: item1.classID,
									comment: item1.Comment,
									sexFlg: item1.SexFlg,
									smokingFlg: item1.SmokingFlg,
									stayMealDateList: item1.StayMealDateList.map(
										(
											it: IClassStayMealInfo
										): {
											[key: string]:
												| string
												| boolean
												| null;
										} => ({
											executionDate: it.ExecutionDate,
											mealAfternoonFlg:
												it.MealAfternoonFlg,
											mealEveningFlg: it.MealEveningFlg,
											mealMorningFlg: it.MealMorningFlg,
											stayFlg: it.StayFlg,
										})
									),
								})
							),
						})
					),
					careerType: arg.careerType,
					reason: arg.reason,
				};

				return this.create(
					'per_search_ApprovalReasonBlockModel',
					param
				).then(data => {
					this.dispatch(
						Actions.setApprovalResult({
							data: {
								errorMessageList: data.errorMessageList,
								exceptionEndFlg: data.exceptionEndFlg,
								success:
									!data.errorMessageList ||
									data.errorMessageList.length === 0,
							},
							isOpenApprovalResult: true,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 申請変更シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createUpdateApplyCareers(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			ICancelAndUpdateClassParam
		> {
			protected process(arg: ICancelAndUpdateClassParam) {
				const applyParam = {
					accessType: '10',
					applies: arg.careerAppl.applies.map(
						(
							item: Actions.IApply
						): {
							[key: string]: string | boolean | null | any;
						} => ({
							approverId1: item.approverId1,
							approverId2: item.approverId2,
							approverId4: item.approverId4,
							cancelWaitFlg: item.cancelWaitFlg,
							careerId: item.careerId,
							classId: item.classId,
							stayMealData: item.stayMealData.map(
								(
									item1: Actions.IApprovalStayMealData
								): {
									[key: string]:
										| string
										| boolean
										| null
										| any;
								} => ({
									UID: item1.UID,
									careerID: item1.careerID,
									classID: item1.classID,
									comment: item1.Comment,
									sexFlg: item1.SexFlg,
									smokingFlg: item1.SmokingFlg,
									stayMealDateList: item1.StayMealDateList.map(
										(
											it: IClassStayMealInfo
										): {
											[key: string]:
												| string
												| boolean
												| null;
										} => ({
											executionDate: it.ExecutionDate,
											mealAfternoonFlg:
												it.MealAfternoonFlg,
											mealEveningFlg: it.MealEveningFlg,
											mealMorningFlg: it.MealMorningFlg,
											stayFlg: it.StayFlg,
										})
									),
								})
							),
						})
					),
					careerType: arg.careerAppl.careerType,
					reason: arg.careerAppl.reason,
				};

				const cancelParam = {
					accessType: '10',
					aplType: arg.reqCancelReq.aplType,
					careerID: arg.reqCancelReq.careerID,
					classID: arg.reqCancelReq.classID,
					lang: arg.reqCancelReq.userAttr.lang,
					locale: arg.reqCancelReq.userAttr.locale,
					userId: arg.reqCancelReq.userAttr.userId,
				};
				const param: IOptions = {
					careerAppl: applyParam,
					reqCancelReq: cancelParam,
				};

				return this.create(
					'per_search_ApprovalReasonUpdateBlockModel',
					param
				).then(data => {
					if (!data.tsqErrorMessage) {
						dispatch(
							showChangeApplicationDialog({
								dialogOpen: true,
							})
						);
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	public static FetchClassStayMealDateList(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IStayMealSearchParam
		> {
			protected process(arg: IStayMealSearchParam) {
				const param = {
					careerId: arg.careerId,
					classId: arg.classId,
				};
				return this.read(
					'per_search_StayMealDateListBlockCollection',
					param
				).then(data => {
					if (data.StayMealDateList) {
						const dateList: IStayMealDateList[] =
							data.StayMealDateList;
						this.dispatch(
							Actions.setStayMealDateList({ dateList })
						);
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 「検索」画面情報を取得する。
	 * @param dispatch
	 * @param token
	 */
	public static getCMOptionValue(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<any> {
			protected process(arg: any) {
				const param = {
					userId: '',
				};
				return this.read('per_search_SearchInfoBlockModel', param).then(
					data => {
						const initData = {
							cmFlg: 'Y',
							skillCodeList: [],
						};
						if (data.cmFlg) {
							initData.cmFlg = data.cmFlg;
						}
						if (data.skillCodeList) {
							initData.skillCodeList = data.skillCodeList;
						}
						this.dispatch(
							Actions.setSearchInfo({
								cmFlg: initData.cmFlg,
								skillCodeList: initData.skillCodeList,
							})
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	protected static toSearchCategoryItem(fromItem: any) {
		const toItem: Actions.ISearchCategoryItem = {
			careerType: fromItem.careerType,
			checkBoxDisplayFlg: fromItem.checkBoxDisplayFlg,
			id: fromItem.id,
			level: fromItem.level === null ? 0 : +fromItem.level,
			text: fromItem.text,
			type: fromItem.type,
		};
		if (fromItem.children) {
			toItem.treeChildren = fromItem.children.map((child: any) =>
				this.toSearchCategoryItem(child)
			);
		}
		return toItem;
	}

	/**
	 * カテゴリ情報のツリー構造化
	 * @param fromItem 元データ
	 */
	protected static toCategoryItem(fromItem: any) {
		const toItem: Actions.ICategoryMst = {
			id: fromItem.id,
			level: fromItem.level === null ? 0 : +fromItem.level,
			text: fromItem.text,
			textPath: fromItem.categoryPath,
		};
		if (fromItem.children) {
			toItem.treeChildren = fromItem.children.map((child: any) =>
				this.toCategoryItem(child)
			);
		}
		return toItem;
	}

	/**
	 * トピック情報のツリー構造化
	 * @param fromItem 元データ
	 */
	protected static toCourseTopicItem(fromItem: any) {
		const toItem: Actions.ICourseTopicItem = {
			id: fromItem.id,
			level: fromItem.level === null ? 0 : +fromItem.level,
			text: fromItem.text,
		};
		if (fromItem.children) {
			toItem.treeChildren = fromItem.children.map((child: any) =>
				this.toCourseTopicItem(child)
			);
		}
		return toItem;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/SearchScenarioFactory.ts